import { useState } from "react";

import { Flex, TextInput } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Text } from "components";

interface RequestInfoSectionProps {
  requestNumber?: string;
  collaboratorName?: string;
  onRequestNumberChange?: (value: string) => void;
  onCollaboratorNameChange?: (value: string) => void;
  onRequestNumberBlur?: () => void;
  onCollaboratorNameBlur?: () => void;
}

export const RequestInfoSection = ({
  requestNumber = "",
  collaboratorName = "",
  onRequestNumberChange,
  onCollaboratorNameChange,
  onRequestNumberBlur,
  onCollaboratorNameBlur,
}: RequestInfoSectionProps) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const textToCopy = `${requestNumber} ${collaboratorName}`.trim();
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Flex align="center" gap="md">
      <Flex align="center" gap="xs">
        <Text size="sm" fw={500}>
          {`${t("bankSelection.requestInfo.requestNumber")}:`}
        </Text>
        <TextInput
          value={requestNumber}
          onChange={(e) => onRequestNumberChange?.(e.target.value)}
          onBlur={onRequestNumberBlur}
          size="xs"
          styles={{
            input: {
              width: 120,
              height: 32,
              borderRadius: 6,
            },
          }}
        />
      </Flex>

      <Flex align="center" gap="xs">
        <Text size="sm" fw={500}>
          {`${t("bankSelection.requestInfo.collaboratorName")}:`}
        </Text>
        <TextInput
          value={collaboratorName}
          onChange={(e) => onCollaboratorNameChange?.(e.target.value)}
          onBlur={onCollaboratorNameBlur}
          size="xs"
          styles={{
            input: {
              width: 150,
              height: 32,
              borderRadius: 6,
            },
          }}
        />
      </Flex>

      <Flex
        align="center"
        gap={4}
        style={{ cursor: "pointer" }}
        onClick={handleCopy}
      >
        <IconCopy size={16} color="var(--mantine-color-green-7)" />
        <Text size="sm" c="var(--mantine-color-green-7)">
          {copied ? t("bankSelection.requestInfo.copied") : t("bankSelection.requestInfo.copy")}
        </Text>
      </Flex>
    </Flex>
  );
};
